import React, { useContext, useEffect, useRef, useState } from "react";
import MapTopBooked from "./Map/Map";
import axiosInstance from "../../../axiosInstance";
import { useSelector } from "react-redux";
import {
  Box,
  Card,
  CircularProgress,
  Typography,
  useTheme,
} from "@mui/material";
import TopBookedProgressBars from "./TopBookedProgressBars/TopBookedProgressBars";
import DateRangeContext from "../../../contexts/Dashboard/DateRange";
import { useTranslation } from "react-i18next";

const TopBookedCountries = ({ open }) => {
  const lightMode = useSelector((state) => state.mode.lightMode); // Redux state'inden lightMode değerini çekin
  const { startDate, endDate } = useContext(DateRangeContext);
  const [loading, setLoading] = useState(false);
  const [locationDatas, setLocationDatas] = useState([]);
  const [hoveredLocation, setHoveredLocation] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [bookingDetails, setBookingDetails] = useState({
    display: false,
    details: null,
  });
  const { t } = useTranslation();

  const selectedBranchesString = useSelector(
    (state) => state?.branches?.branchesString
  );
  const mapRef = useRef(null);

  const getLocations = async () => {
    let accessToken = localStorage.getItem("accessToken");
    let token = localStorage.getItem("loginUser");
    setLoading(true);
    try {
      const formattedStartDate = startDate.format("YYYY-MM-DD");
      const formattedEndDate = endDate.format("YYYY-MM-DD");
      const response = await axiosInstance.get(
        `dashboard/top_booked_countries?start_date=${formattedStartDate}&end_date=${formattedEndDate}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`, // Bearer token burada ekleniyor
            XRefreshToken: `${token}`, // Bearer token burada ekleniyor,
            Accounts: selectedBranchesString,
            "Content-Type": "application/json", // Eğer gönderdiğiniz veri JSON formatındaysa bu başlık gerekli
          },
        }
      );
      // setLocationDatas(response.data.nationalities);
      const filteredData = response.data.nationalities.filter(
        (nationality) => Object.keys(nationality.location).length !== 0
      );
      setLocationDatas(filteredData);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error sending data:", error.response);
    }
  };

  useEffect(() => {
    getLocations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate, selectedBranchesString]);

  useEffect(() => {
    setHoveredLocation(null);
    setSelectedLocation(null);
  }, [lightMode]);

  const theme = useTheme();
  return (
    <Box sx={{ width: "100%" }}>
      <Card
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {!loading ? (
          <Box position={"relative"} width={"100%"}>
            <Box>
              <Typography
                variant="h5"
                color={lightMode ? theme.palette.customRed.orange : "#ffffff"}
                sx={{
                  fontWeight: "700",
                  mr: "auto",
                  width: "100%",
                  p: 2,
                  pb: 1,
                  textTransform: 'uppercase',
                  borderBottom: `1px dashed ${lightMode ? `#e9ecee` : `#333e47`
                    } `,
                }}
              >
                {t("salesBasedOnCountries")}
              </Typography>
            </Box>

            <Box position={"relative"}>
              <Card
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: { xs: "column", lg: "row" },
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                  p: 2
                }}
              >
                <MapTopBooked
                  mapRef={mapRef}
                  locationDatas={locationDatas}
                  hoveredLocation={hoveredLocation}
                  setHoveredLocation={setHoveredLocation}
                  selectedLocation={selectedLocation}
                  setSelectedLocation={setSelectedLocation}
                  bookingDetails={bookingDetails}
                  setBookingDetails={setBookingDetails}
                  open={open}
                />
                <Box
                  sx={{
                    position: { xs: "relative", lg: "absolute" },
                    top: { xs: "0", lg: 32 },
                    right: { xs: "0", lg: 32 },
                    width: { xs: "100%", lg: "30%" },
                    display: "flex",
                    alignItems: "center",
                    height: { xs: "auto", lg: "calc(100% - 64px)" },
                    marginTop: { xs: "1rem", lg: 0 },
                    zIndex: 9,
                  }}
                >
                  <Card
                    sx={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "1rem",
                      background: lightMode
                        ? `${theme.palette.primary.light}70`
                        : "#00000070",
                      height: locationDatas?.length ? "100%" : "100%",
                    }}
                  >
                    <TopBookedProgressBars
                      locationDatas={locationDatas}
                      hoveredLocation={hoveredLocation}
                      setHoveredLocation={setHoveredLocation}
                      selectedLocation={selectedLocation}
                      setSelectedLocation={setSelectedLocation}
                      bookingDetails={bookingDetails}
                      setBookingDetails={setBookingDetails}
                    />
                  </Card>
                </Box>
              </Card>
            </Box>
          </Box>
        ) : (
          <CircularProgress sx={{ margin: "auto" }} />
        )}
      </Card>
    </Box>
  );
};

export default TopBookedCountries;
